import _ from 'lodash';

export const updateRelatedAddOnOpcodes = (opcode, payload, action) => {
    if (opcode.addOnOpcodes && opcode.addOnOpcodes.opcodes && opcode.addOnOpcodes.opcodes.length) {
        const index = opcode.addOnOpcodes.opcodes.findIndex(x => x.opcode === payload.opcode.opcode);
        return index !== -1
            ? {
                ...opcode,
                addOnOpcodes: {
                    ...opcode.addOnOpcodes,
                    opcodes: Object.assign([], opcode.addOnOpcodes.opcodes, {
                        [index]: (opcode.addOnOpcodes.opcodes[index].opcode === payload.opcode.opcode
                            ? (action === 'update' ? { ...opcode.addOnOpcodes.opcodes[index], opcodeDetails: payload.opcode } :{})
                            : opcode.addOnOpcodes.opcodes[index])
                    })
                }
            }
            : opcode
    } else {
        return opcode
    }
} 

export const checkAllOpcodes = (opcodes, query) =>{
    if(opcodes.length > 0){
        if(opcodes.findIndex(o => o.opcode?.toLowerCase() === query?.toLowerCase()) !== -1 )
        {
          return true;
        }
    }
    return false;
}

export const updateRelatedAddOnAspOpcodes = (opcode, payload) => {
    if (opcode.addOnOpcodes && opcode.addOnOpcodes.opcodes && opcode.addOnOpcodes.opcodes.length) {
        const index = opcode.addOnOpcodes.opcodes.findIndex(x => x.opcode === payload.aspServiceCode);
        return index !== -1
            ? {
                ...opcode,
                addOnOpcodes: {
                    ...opcode.addOnOpcodes,
                    opcodes: Object.assign([], opcode.addOnOpcodes.opcodes, {
                        [index]: (opcode.addOnOpcodes.opcodes[index].opcode === payload.aspServiceCode
                            ? { opcode: payload.opcode.opcode , opcodeDetails: payload.opcode }
                            : opcode.addOnOpcodes.opcodes[index])
                    })
                }
            }
            : opcode
    } else {
        return opcode
    }
}
export const updateAspOpcodes = (opcode, payload) => {
    return (opcode && opcode.opcode === payload.aspServiceCode) ? payload.opcode : opcode;
}

export const transformOpcodeData = (data) => {
    return  _.groupBy(data,(obj) =>{
        const key = obj.SK.split("#")[0]
      if(key === "OPCODE"){
          return "dmsOpcodes"
      }else if(key === "MAINTENANCECODE"){
          return "maintenanceOpcodes"
      }else if(key === "COMPLAINTCODE"){
          return "complaintOpcodes"
      }else{
        return key
      }
    });

}
